import theme from './base.variable';

export default theme;
